import { MuteButton as ControlMenuV2MuteButton } from "@/modules/calling/control-menu/v2/buttons/mute-button";

export const MuteButton = () => {
  return <ControlMenuV2MuteButton className="w-16 animate-fadein" />;
};
